import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import MissMFCBadge from './MissMFC';
import NewBadge from './New';
import "./NewAndMissMFC.linaria.module.css!=!./NewAndMissMFC?./NewAndMissMFC.linaria.module.css?css=H4sIAAAAAAAAA3WT0XKDIBBF3/sbnT6agUB0Sj+GQQEloljEJJbpv3diqgJNH+9wzy7sXg7MdRQjCmeMjZaHWPrSWC5sVhrnTJdpIV1mGVfTSPBw+/h+Wfx5FeG7XHFnhsyqunkGy4rCJjfn6SuR/jyNTsk5q0zvRO9IJXon7Mo1EbYpz7Sq+0w50Y0JoQ1VfJA1jpUfGOeqr++3JGAzi8gsUvNjIoG/pVAXJWI2kRtxHx5B+8O1jgn9h1hGFiJHTqe8kHCMlS9Z1dbWTD3PKqONJa9SyhV6Hyl0t6u6aM/VOGg2E6nFVrPF1NTFzXXeDKxSbibgkJ/W00JTyPNuFmf/WxkhtB7iE50bDEoZqyQ00eKPUWoCelP/ZiZAMYoao+eNw7SGfVnUlz3p+w95mSk046c5XvxVcdcQCMDblkcUrXOXvmO2Vv0Sr2CXDQgDtqnV/dh9GK8wjm0axyVcIIhW6NapOynegOj/7jK+zOPT/gCZPW2bMQQAAA=="
interface NewAndMissMFCBadgesProps {
  enablePinToTopSymbols?: boolean;
  isPinnedToTopMissMFC?: boolean;
  missMFCCompact?: boolean;
  missMFCRank?: number;
  showMissMFC?: boolean;
  showNew?: boolean;
  style?: CSSProperties;
  className?: LinariaClassName;
}
const missMfcBadgeStyles = "atm_43_1y44olf atm_6c_1y44olf atm_fc_1h6ojuz atm_h_1h6ojuz atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1l7b3ar atm_ll_1l7b3ar atm_2d_u67f1s atm_9s_1txwivl atm_k4_og7xtm atm_7l_1d6myej";
const detailedMissMfcBadgeStyles = "atm_45_yh40bf atm_6c_yh40bf atm_43_yh40bf atm_6a_yh40bf atm_vy_1osqo2v atm_h3_1l7b3ar";
const stylesNewBadge = "atm_h0_idpfg4 atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4";
const styleShowMissMFC = "atm_h0_1y44olf";
const NewAndMissMFCBadges = memo((props: NewAndMissMFCBadgesProps) => {
  const {
    enablePinToTopSymbols,
    isPinnedToTopMissMFC,
    missMFCCompact,
    missMFCRank,
    showMissMFC,
    className,
    showNew,
    style
  } = props;
  if (enablePinToTopSymbols && !isPinnedToTopMissMFC) {
    return null;
  }
  return <div className={cx(missMfcBadgeStyles, detailedMissMfcBadgeStyles, className)} style={style}>
            {showNew && <NewBadge className={cx(stylesNewBadge, showMissMFC && styleShowMissMFC)} />}
            {showMissMFC && <MissMFCBadge missMFCRank={missMFCRank} compact={missMFCCompact} />}
        </div>;
});
export default NewAndMissMFCBadges;
export { NewAndMissMFCBadges };